import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { Logo, Spinner } from "@/components/rp";
import { CompareSlider } from "@/components/CompareSlider";

const API = process.env.REACT_APP_BACKEND_URL;

const Block = ({ label, ids, img, testid }) => (
  <section className="space-y-3" data-testid={testid}>
    <p className="rp-label">{label}</p>
    <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
      {ids.map((id) => <img key={id} src={img(id)} alt={label} loading="lazy" className="aspect-[4/3] w-full rounded-2xl object-cover bg-[#F1EDE6]" />)}
    </div>
  </section>
);

export default function PrimaDopoPage() {
  const { oid } = useParams();
  const [params] = useSearchParams();
  const t = params.get("t") || "";
  const [d, setD] = useState(null);
  const [bad, setBad] = useState("");
  useEffect(() => { api.get(`/public/prima-dopo/${oid}`, { params: { t } }).then((r) => setD(r.data)).catch((e) => setBad(errMsg(e))); }, [oid, t]);
  const img = (id) => `${API}/api/public/prima-dopo/${oid}/img/${id}?t=${t}`;
  return (
    <div className="min-h-screen bg-white px-6 py-10">
      <div className="max-w-5xl mx-auto space-y-10" data-testid="prima-dopo-page">
        <Logo className="h-8" />
        {bad && <p className="text-[#DC3545]" data-testid="prima-dopo-invalid">{bad}</p>}
        {!d && !bad && <Spinner />}
        {d && (
          <>
            <div>
              <p className="rp-label">Prima e dopo · {d.code}</p>
              <h1 className="text-4xl sm:text-5xl font-semibold tracking-tight mt-2">{d.title}</h1>
              {d.client_first && <p className="text-[#757575] mt-3">Grazie {d.client_first} per averci affidato la tua casa.</p>}
            </div>
            {d.pairs.length > 0 && (
              <section className="space-y-3" data-testid="prima-dopo-pairs">
                <p className="rp-label">Trascina il cursore per confrontare</p>
                <div className="grid md:grid-cols-2 gap-6">{d.pairs.map((x, i) => <CompareSlider key={i} before={img(x.prima)} after={img(x.dopo)} label={x.ambiente} testid={`compare-${i}`} />)}</div>
              </section>
            )}
            {d.prima.length > 0 && <Block label={d.pairs.length ? "Altre foto prima" : "Prima"} ids={d.prima} img={img} testid="prima-dopo-before" />}
            {d.dopo.length > 0 && <Block label={d.pairs.length ? "Altre foto dopo" : "Dopo"} ids={d.dopo} img={img} testid="prima-dopo-after" />}
          </>
        )}
      </div>
    </div>
  );
}
